// extracted by mini-css-extract-plugin
export default {"inputMessage":"InputMessage_inputMessage__E1Mqs"};